export const createWebSocketHandlers = () => ({
  login: (message) => {
    console.log('Авторизованный пользователь успешно залогинился: ', JSON.stringify(message))
  },

  ticket: (message, context) => {
    if (message.prm === 'update') {
      context.dashboardStore.handleTicketUpdate(message.dat)
    }
  },
})
